<template>
  <div>
    <section class="hero is-dark">
      <div class="logo">
        <img width="12%" src="@/assets/logo2.png" alt="Logo"/>
      </div>
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title has-text-white is-2">Líderes PHD</h1>
          <h2 class="subtitle has-text-white is-4">Personas que hacen la diferencia</h2>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="box has-background-white-ter">
          <div v-show="pase === 0">
            <h1 class="title">
              {{ candidate.isBoss ? title.lider : title.colaboradores }} <span v-if='candidate.isBoss'>{{relacion.evaluador.nombre}}</span>
            </h1>
            <h2 class="subtitle" v-if='!candidate.isBoss'>
              Aquí vas a evaluar a
              <strong>{{ relacion.evaluado.nombre }}</strong>
            </h2>
            <!-- <p class="is-medium">{{title[tipo]}}</p> -->
            <div class="has-text-left">
              <span style="white-space: pre-line">
                {{ candidate.isBoss ? infoForUser.lider.Lider : infoForUser.colaboradores.Colaborador }}
              </span>
              <br/>
              <h2
                  class="title is-7"
              >*Si tienes dificultades comunícate con elena@sietegho.com</h2>
            </div>
            <br/>
            <br/>
            <div class="control">
              <modal-consentimiento
                  :show="!responses.agree"
                  @aceptConsent=aceptConsent
                  @next=next
                  @endno=endno
                  :isAgree="responses.agree"
                  :isBoss="candidate.isBoss"
              ></modal-consentimiento>
              <button
                  v-show="responses.agree"
                  @click="next()"
                  class="button is-dark"
                  :disabled="!responses.agree"
              >Siguiente
              </button>
            </div>
            <br/>
            <!--            <div class="has-text-centered">
                          <button
                              v-show="responses.agree"
                              @click="next()"
                              class="button is-dark"
                              :disabled="!responses.agree"
                          >Siguiente
                          </button>
                          <button
                              v-show="!responses.agree"
                              @click="endno()"
                              class="button is-is-dark"
                          >Terminar y Guardar
                          </button>
                        </div>-->
          </div>
          <div v-show="pase === 1">
            <div class="field">
              <label class="label">Género</label>
              <ul>
                <li>
                  <input
                      class="is-checkradio is-info"
                      type="radio"
                      id="genrem"
                      value="Masculino"
                      v-model="responses.genre"
                  />
                  <label for="genrem" class="is-capitalized">Masculino</label>
                </li>
                <li>
                  <input
                      class="is-checkradio is-info"
                      type="radio"
                      id="genref"
                      value="Femenino"
                      v-model="responses.genre"
                  />
                  <label for="genref" class="is-capitalized">Femenino</label>
                </li>
                <li>
                  <input
                      class="is-checkradio is-info"
                      type="radio"
                      id="genreo"
                      value="Otro"
                      v-model="responses.genre"
                  />
                  <label for="genreo" class="is-capitalized">Otro</label>
                </li>
              </ul>
            </div>
            <div class="field">
              <label class="label">Edad</label>
              <div class="control">
                <input
                    class="input is-is-dark"
                    type="number"
                    style="width : auto"
                    name="age"
                    v-model="responses.age"
                    placeholder="Ingrese su edad"
                />
                <!-- <label class="radio">
                <input type="radio" name="age" v-model="responses.age" value="18-36" /> 18 a 36 años
              </label>
              <br />
              <label class="radio">
                <input type="radio" name="age" v-model="responses.age" value="37-51" />37 a 51 años
              </label>
              <br />
              <label class="radio">
                <input type="radio" name="age" v-model="responses.age" value="52-65" />52 a 65 años
                </label>-->
              </div>
            </div>

            <div class="field">
              <label class="label">Nivel Educativo Alcanzado</label>
              <ul>
                <li>
                  <input
                      class="is-checkradio is-info"
                      type="radio"
                      id="educationnin"
                      value="ninguno"
                      v-model="responses.education"
                  />
                  <label for="educationnin" class="is-capitalized">Ninguno</label>
                </li>
                <li>
                  <input
                      class="is-checkradio is-info"
                      type="radio"
                      id="educationpri"
                      value="primaria-completa"
                      v-model="responses.education"
                  />
                  <label for="educationpri" class="is-capitalized">Primaria completa</label>
                </li>
                <li>
                  <input
                      class="is-checkradio is-info"
                      type="radio"
                      id="educationbachi"
                      value="bachillerato-completo"
                      v-model="responses.education"
                  />
                  <label for="educationbachi" class="is-capitalized">Bachillerato completo</label>
                </li>
                <li>
                  <input
                      class="is-checkradio is-info"
                      type="radio"
                      id="educationtecn"
                      value="Tecnico/tecnologico-completo"
                      v-model="responses.education"
                  />
                  <label for="educationtecn" class="is-capitalized">Tecnico/tecnologico completo</label>
                </li>
                <li>
                  <input
                      class="is-checkradio is-info"
                      type="radio"
                      id="educationpro"
                      value="profesional-completo"
                      v-model="responses.education"
                  />
                  <label for="educationpro" class="is-capitalized">Profesional completo</label>
                </li>
                <li>
                  <input
                      class="is-checkradio is-info"
                      type="radio"
                      id="educationpost"
                      value="post-grado-completo"
                      v-model="responses.education"
                  />
                  <label for="educationpost" class="is-capitalized">Post-grado completo</label>
                </li>
              </ul>
            </div>
            <div class="field">
              <label class="label">País</label>
              <p class="control has-icons-left">
                <span class="select is-is-dark">
                  <select name="country" v-model="responses.country">
                    <option></option>
                    <option v-for="(name, index) in countryNames" :key="index">{{ name }}</option>
                  </select>
                </span>
                <span class="icon is-small is-left">
                  <i class="material-icons">language</i>
                </span>
              </p>
            </div>
            <div class="field">
              <label class="label">Ciudad</label>
              <p class="control has-icons-left">
                <span class="select is-is-dark">
                  <select name="city" v-model="responses.city" @change="showOtherC($event)">
                    <option></option>
                    <option :key="otherC === '' ? 'Otra...' : otherC.toUpperCase()">
                      {{ otherC === '' ? 'Otra...' : otherC.toUpperCase() }}</option>
                    <option v-for="(name, index) in citysNames[responses.country]" :key="index">{{ name }}</option>
                  </select>
                </span>
                <span class="icon is-small is-left">
                  <i class="material-icons">language</i>
                </span>
              </p>
            </div>
            <div class="field">
              <label v-show="showOtherInput" class="label">Otra Ciudad</label>
              <input
                  v-show="showOtherInput"
                  class="input is-is-dark"
                  type="text"
                  style="width : auto"
                  name="otherCity"
                  v-model="otherC"
                  placeholder="Ingrese su Ciudad"
              />
            </div>
            <br/>
            <div class="field has-text-centered">
              <!--              <button @click="prev()" class="button is-is-dark">Anterior</button>-->
              <button
                  @click="next()"
                  class="button is-is-dark"
                  :disabled="(!this.responses.genre || !this.responses.age || !this.responses.education) || !this.responses.country || !(this.responses.city !== 'Otra...' && this.responses.city)"
              >Siguiente
              </button>
            </div>
          </div>
          <div v-show="pase === 2">
            <strong>Instrucciones:</strong>
            <br/>
            <br/>
            <p>{{ candidate.isBoss ? instruccion.lider.parrafo1 : instruccion.colaboradores.parrafo1 }}</p>
            <br/>
            <p>{{ candidate.isBoss ? instruccion.lider.parrafo2 : instruccion.colaboradores.parrafo2 }}</p>
            <br/>
            <p>
              <strong>{{ candidate.isBoss ? instruccion.lider.parrafo3 : instruccion.colaboradores.parrafo3 }}</strong>
            </p>
            <br/>
            <p>Si estás mas o menos en desacuerdo con esta afirmación puedes marcar así:</p>
            <img
                v-show="candidate.isBoss"
                src="@/assets/ejemploa1.png"
                width="700px"
                style="margin-top:2px;"
            />
            <img
                v-show="!candidate.isBoss"
                src="@/assets/ejemploa1(c).png"
                width="700px"
                style="margin-top:2px;"
            />
            <p>Si estás mas o menos de acuerdo con esta afirmación puedes marcar así:</p>
            <img
                v-show="candidate.isBoss"
                src="@/assets/ejemploa2.png"
                width="700px"
                style="margin-top:2px;"
            />
            <img
                v-show="!candidate.isBoss"
                src="@/assets/ejemploa2(c).png"
                width="700px"
                style="margin-top:2px;"
            />

            <div class="field has-text-centered">
              <button @click="prev()" class="button is-is-dark">Anterior</button>
              <button @click="next()" class="button is-is-dark">Siguiente</button>
            </div>
          </div>
          <div class="pase has-text-left question" v-show="pase === 3">
            <h2 class="title is-5">
              <strong
                  v-show="candidate.isBoss"
              >Autoevaluación líderes - {{ relacion.evaluado.nombre }}</strong>
              <strong v-show="!candidate.isBoss">Estás evaluando a {{ relacion.evaluado.nombre }}</strong>
            </h2>
            <img src="@/assets/ejemplo4.png" width="900px" style="margin-top:-20px;"/>
            <br/>
            <br/>
            <progress class="progress is-success" :value="page / numberOfPages * 100" max="100">%</progress>
            <div class="field" v-for="(question, index) in displayedQuestions" :key="index">
              <label class="label">
                <strong>{{ question.numeroPregunta }}.</strong>
                {{ candidate.isBoss ? question.lider : question.colaboradores }}
                <br/>
              </label>
              <div class="control" :key="index">
                <input
                    v-if="!candidate.isBoss"
                    required
                    class="is-checkradio is-info"
                    type="radio"
                    :id="question.codigo+ '00'"
                    value="0"
                    v-model="responses[question.codigo]"
                />
                <label
                    v-if="!candidate.isBoss"
                    :for="question.codigo+ '00'"
                    class="is-capitalized"
                >No sé</label>
                <input
                    required
                    class="is-checkradio is-info"
                    type="radio"
                    :id="question.codigo+ '01'"
                    value="1"
                    v-model="responses[question.codigo]"
                />
                <label :for="question.codigo+'01'" class="is-capitalized">1</label>
                <input
                    required
                    class="is-checkradio is-info"
                    type="radio"
                    :id="question.codigo+'02'"
                    value="2"
                    v-model="responses[question.codigo]"
                />
                <label :for="question.codigo+'02'" class="is-capitalized">2</label>
                <input
                    required
                    class="is-checkradio is-info"
                    type="radio"
                    :id="question.codigo+'03'"
                    value="3"
                    v-model="responses[question.codigo]"
                />
                <label :for="question.codigo+'03'" class="is-capitalized">3</label>
                <input
                    required
                    class="is-checkradio is-info"
                    type="radio"
                    :id="question.codigo+'04'"
                    value="4"
                    v-model="responses[question.codigo]"
                />
                <label :for="question.codigo+'04'" class="is-capitalized">4</label>
                <input
                    required
                    class="is-checkradio is-info"
                    type="radio"
                    :id="question.codigo+'05'"
                    value="5"
                    v-model="responses[question.codigo]"
                />
                <label :for="question.codigo +'05'" class="is-capitalized">5</label>
                <input
                    required
                    class="is-checkradio is-info"
                    type="radio"
                    :id="question.codigo +'06'"
                    value="6"
                    v-model="responses[question.codigo]"
                />
                <label :for="question.codigo +'06'" class="is-capitalized">6</label>
                <input
                    required
                    class="is-checkradio is-info"
                    type="radio"
                    :id="question.codigo+ '07'"
                    value="7"
                    v-model="responses[question.codigo]"
                />
                <label :for="question.codigo+'07'" class="is-capitalized">7</label>
                <input
                    required
                    class="is-checkradio is-info"
                    type="radio"
                    :id="question.codigo +'08'"
                    value="8"
                    v-model="responses[question.codigo]"
                />
                <label :for="question.codigo +'08'" class="is-capitalized">8</label>
                <input
                    required
                    class="is-checkradio is-info"
                    type="radio"
                    :id="question.codigo +'09'"
                    value="9"
                    v-model="responses[question.codigo]"
                />
                <label :for="question.codigo +'09'" class="is-capitalized">9</label>
                <input
                    required
                    class="is-checkradio is-info"
                    type="radio"
                    :id="question.codigo+ '10'"
                    value="10"
                    v-model="responses[question.codigo]"
                />
                <label :for="question.codigo+'10'" class="is-capitalized">10</label>
              </div>
            </div>
            <div class="buttons">
              <button
                  type="button"
                  @click="page --; scrollTop()"
                  v-if="page != 1"
                  class="button is-is-dark"
              >Anterior
              </button>
              <button
                  type="button"
                  @click="nextquestions"
                  v-if="page != numberOfPages"
                  class="button is-link"
                  :disabled="!(Object.keys(responses).length - numberOfOthersResponses > (page * perPage) -1)"
              >Siguiente
              </button>
              <br/>
            </div>
            <div class="buttons is-centered">
              <button
                  @click="end()"
                  class="button is-success"
                  v-if="page == numberOfPages"
                  :disabled="!(questions.length == Object.keys(responses).length - numberOfOthersResponses)"
              >Finalizar
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import apiServices from "@/services/yungol-services";
import json from "./infoEncuesta.json";
import modalConsentimiento from "../modals/ModalConsentimiento";

export default {
  data() {
    return {
      relacion: {
        evaluado: "",
        evaluador: "",
      },
      pase: 0,
      candidate: {},
      isBoss: null,
      responses: {
        agree: false,
      },
      countryNames: json.countrys,
      citysNames: json.citys,
      otherC: "",
      showOtherInput: "",
      title: json.title,
      consentimiento: json.consentimiento,
      infoForUser: json.welcome,
      instruccion: {
        lider: {
          parrafo1:
              "Vas a encontrarte afirmaciones que describen comportamientos de los líderes. Responde en una escala de 1 a 10 qué tanto consideras que tu actúas de esa manera. Ten en cuenta que el 1 corresponde a “Totalmente en desacuerdo” y el 10 a “Totalmente de acuerdo”, puedes utilizar todos los niveles intermedios para expresar lo que piensas.",
          parrafo2:
              "Recuerda que no hay respuestas buenas o malas. Lo que importa es conocer tu percepción frente a tu comportamiento como líder. Trata de responder rápidamente, no te detengas mucho en cada afirmación.",
          parrafo3: "A continuación te presentamos algunos ejemplos:",
        },
        colaboradores: {
          parrafo1:
              "Vas a encontrarte afirmaciones que describen comportamientos de los líderes. Responde en una escala de 1 a 10 qué tanto consideras que tu líder actúa de esa manera. Ten en cuenta que el 1 corresponde a “Totalmente en desacuerdo” y el 10 a “Totalmente de acuerdo”, puedes utilizar todos los niveles intermedios para expresar lo que piensas. Evita usar la opción “No sé” o utilízala lo menos posible y solo cuando sea estrictamente necesario.",
          parrafo2:
              "Recuerda que no hay respuestas buenas o malas. Lo que importa es conocer tu percepción frente al comportamiento de tu líder. Trata de responder rápidamente, no te detengas mucho en cada afirmación.",
          parrafo3: "A continuación te presentamos algunos ejemplos:",
        },
      },
      tipo: "colaboradores",
      questions: json.questions,
      othersQuestions: ['agree', 'genre', 'age', 'education', 'country', 'city'],
      numberOfOthersResponses: 6,
      page: 1,
      perPage: 8,
      numberOfPages: 0,
    };
  },
  methods: {
    scrollTop() {
      window.scrollTo({
        behavior: "smooth",
        left: 0,
        top: 200,
      });
    },
    aceptConsent(res) {
      this.responses.agree = res
    },
    async traerParrafo() {
      let id = {
        id: this.$route.params.id
      }
      const result = await apiServices.post('infoemail', id);

      if (result.data.length){
        const keys = Object.keys(result.data[0])
        if (keys.includes('colaborador') && keys.includes('lider')) {
          if (result.data[0].lider.cuerpo) {
            this.infoForUser.lider.lider = result.data[0].lider.cuerpo
          }
          if (result.data[0].colaborador.cuerpo) {
            this.infoForUser.colaboradores.Colaborador = result.data[0].colaborador.cuerpo
          }
          if (result.data[0].lider.title){
            this.title.lider = result.data[0].lider.title
          }
          if (result.data[0].colaborador.title){
            this.title.colaboradores = result.data[0].colaborador.title
          }
        }
      }
    },
    async traerelaciones() {
      this.relaciones = [];
      let result;
      try {
        result = await apiServices.get(
            `/relacionbyid/${this.$route.params.id}`
        );
        if (result.data) {
          if (!result.data.proceso.status){
            await this.$router.replace({name: "closeSurvey"});
          }else {
            this.relacion = result.data;
            if (result.data.responses) {
              this.responses = result.data.responses;
            }
            const cantidadresponses = Object.keys(this.responses).length;
            this.numberOfOthersResponses = Object.keys(this.responses).filter(v => {
              if (this.othersQuestions.includes(v)){
                return v;
              }
            }).length;

            if (cantidadresponses >= 6) {
              this.pase = 3;
              const cantidad = cantidadresponses - this.numberOfOthersResponses;
              console.log("cantidad", cantidad);
              const calculo = Math.ceil(cantidad / this.perPage);
              console.log("calculo", calculo);

              this.page = calculo ? calculo.toFixed(0) : (calculo+1).toFixed(0)
            }
            if (this.relacion.relacion === "Autoevaluacion") {
              this.candidate.isBoss = true;
            } else {
              this.candidate.isBoss = false;
            }
            if (
                this.relacion.status === "terminado" ||
                this.relacion.status === "calculado"
            ) {
              await this.$router.replace({name: "finencuesta"});
            }
          }
        } else {
          await this.$router.replace({name: "finencuesta"});
        }
      } catch (err) {
        console.log(err);
      }
    },
    async saveresponses(end) {
      this.relaciones = [];
      const d = {
        id: this.$route.params.id,
        responses: this.responses,
      };
      if (end) {
        d.end = true;
      }
      try {
        await apiServices.post(`/saveresponseslider`, d);
      } catch (err) {
        console.log(err);
      }
    },
    prev() {
      this.pase -= 1;
    },
    next() {
      this.pase += 1;
      this.saveresponses();
    },
    nextquestions() {
      this.saveresponses();
      this.page++;
      this.scrollTop();
    },
    end() {
      if (this.checkresponses()) {
        this.saveresponses(true);
        this.$store.dispatch("notify", {
          message: `Perfecto. Encuesta finalizada con éxito`,
        });
        this.$router.replace({name: "finencuesta"});
        setTimeout(function () {
          window.location.replace("https://sietegho.com");
        }, 3000);
      }
    },
    endno() {
      this.saveresponses(false);
      this.$store.dispatch("notify", {
        message: `Perfecto. Proceso finalizado con éxito`,
      });
      this.$router.replace({name: "finencuesta"});
      setTimeout(function () {
        window.location.replace("https://sietegho.com");
      }, 3000);
    },
    checkresponses() {
      // verifica que todas las preguntas del formulario sean respondidas
      let x = 0;
      let i;
      for (i = 0; i < this.questions.length; i++) {
        // verifica que el objeto responses tenga la propiedad (variable codigo) de cada pregunta
        if (!this.responses.hasOwnProperty(this.questions[i].codigo)) {
          x++;
        }
      }
      if (x > 0) {
        this.$store.dispatch("notify", {
          message: "Aún le falta(n) " + x + " pregunta(s) por responder!",
          type: "is-warning",
          position: "top-center",
        });
        return false;
      } else {
        return true;
      }
    },
    paginate(questions) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return questions.slice(from, to);
    },
    showOtherC(e) {
      if (this.citysNames[this.responses.country][e.target.value] === undefined) {
        this.showOtherInput = true
      } else {
        this.showOtherInput = false
      }
    }
  },
  computed: {
    displayedQuestions() {
      return this.paginate(this.questions);
    },
  },
  created() {
    this.traerelaciones();
  },
  watch: {
    otherC(val) {
      this.responses.city = val.toUpperCase()
    },
    relacion(nv){
     if (nv){
       if (this.relacion.evaluado){
         this.numberOfPages = Math.ceil(this.questions.length / this.perPage);
         this.questions.forEach((question, index) => {
           question.numeroPregunta = index + 1;
           return question;
         });
         this.traerParrafo()
       }
     }
    },
    pase(nv){
      if (Object.keys(this.responses).length < 7){
        this.numberOfOthersResponses = Object.keys(this.responses).filter(v => {
          if (this.othersQuestions.includes(v)){
            return v;
          }
        }).length;
      }
    }
  },
  components: {
    modalConsentimiento
  }
};
</script>

<style lang='scss'>
.logo {
  top: 15px;
  z-index: 31;
  margin-left: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/EncuestaLider.vue